import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import {
  AlertaLucrosAcumuladosResponse,
  CalcularDividendoPreviewRequest,
  CalcularDividendoPreviewResponse,
  DividendoResponse,
  InserirDividendoRequest,
  ListarDividendoRequest,
  RetificarDividendoRequest
} from '../models/dividendo.model';
import { FormaDistribuicaoDividendoEnum } from '../models/enums/dividendo.enum';

@Injectable({
  providedIn: 'root'
})
export class DividendoService {
  private apiUrl = `${environment.advContabilApi}/api/Dividendo`;

  constructor(private http: HttpClient) { }

  inserir(request: InserirDividendoRequest): Observable<DividendoResponse> {
    return this.http.post<DividendoResponse>(`${this.apiUrl}/Inserir`, request, this.jsonHeaders());
  }

  retificar(id: string, request: RetificarDividendoRequest): Observable<DividendoResponse> {
    return this.http.post<DividendoResponse>(`${this.apiUrl}/Retificar/${id}`, request, this.jsonHeaders());
  }

  cancelar(id: string, usuarioId: string): Observable<DividendoResponse> {
    return this.http.post<DividendoResponse>(`${this.apiUrl}/Cancelar/${id}`, null, {
      params: { usuarioId }
    });
  }

  obter(id: string, usuarioId: string): Observable<DividendoResponse> {
    return this.http.get<DividendoResponse>(`${this.apiUrl}/Obter/${id}`, {
      params: { usuarioId }
    });
  }

  listar(filtro: ListarDividendoRequest): Observable<DividendoResponse[]> {
    let params = new HttpParams().set('usuarioId', filtro.usuarioId);

    if (filtro.dataInicio) params = params.set('dataInicio', filtro.dataInicio);
    if (filtro.dataFim) params = params.set('dataFim', filtro.dataFim);
    if (filtro.formaDistribuicao) params = params.set('formaDistribuicao', filtro.formaDistribuicao);
    if (filtro.socioId) params = params.set('socioId', filtro.socioId);
    if (filtro.statusReinf) params = params.set('statusReinf', filtro.statusReinf);
    if (filtro.ordenarPor) params = params.set('ordenarPor', filtro.ordenarPor);
    if (filtro.ordemDecrescente !== undefined) params = params.set('ordemDecrescente', filtro.ordemDecrescente);

    return this.http.get<DividendoResponse[]>(`${this.apiUrl}/Listar`, { params });
  }

  calcularPreview(request: CalcularDividendoPreviewRequest): Observable<CalcularDividendoPreviewResponse> {
    return this.http.post<CalcularDividendoPreviewResponse>(`${this.apiUrl}/CalcularPreview`, request, this.jsonHeaders());
  }

  obterAlertaLucrosAcumulados(
    usuarioId: string,
    valorBrutoTotal: number,
    formaDistribuicao: FormaDistribuicaoDividendoEnum
  ): Observable<AlertaLucrosAcumuladosResponse> {
    return this.http.get<AlertaLucrosAcumuladosResponse>(`${this.apiUrl}/ObterAlertaLucrosAcumulados`, {
      params: {
        usuarioId,
        valorBrutoTotal: valorBrutoTotal.toString(),
        formaDistribuicao
      }
    });
  }

  exportarExcel(filtro: ListarDividendoRequest): Observable<Blob> {
    let params = new HttpParams().set('usuarioId', filtro.usuarioId);

    if (filtro.dataInicio) params = params.set('dataInicio', filtro.dataInicio);
    if (filtro.dataFim) params = params.set('dataFim', filtro.dataFim);
    if (filtro.formaDistribuicao) params = params.set('formaDistribuicao', filtro.formaDistribuicao);
    if (filtro.socioId) params = params.set('socioId', filtro.socioId);
    if (filtro.statusReinf) params = params.set('statusReinf', filtro.statusReinf);

    return this.http.get(`${this.apiUrl}/ExportarExcel`, {
      params,
      responseType: 'blob'
    });
  }

  private jsonHeaders() {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
  }
}
